<template>
  <header
    class="header w-screen items-center"
    :class="inverted ? 'text-primary bg-white' : 'text-white'"
  >
    <div class="container mx-auto px-4 h-16 md:h-20 flex items-center">
      <a href="https://blebox.eu/" target="_blank" class="mr-4 inline-block">
        <img :src="logo" alt="Blebox" class="header__logo h-full">
      </a>

      <Spinner :loading="isLoading" :color="inverted"/>

      <span class="flex-1 text-right">
        <LangSelect/>
      </span>
    </div>
  </header>
</template>

<script>
import Spinner from '@/components/atoms/Spinner';
import LangSelect from '@/components/atoms/LangSelect';
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  components: {
    Spinner,
    LangSelect,
  },

  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),

    logo() {
      return require(this.inverted ? '@/assets/blebox_logo_inverted.svg' : '@/assets/blebox_logo.svg');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.header {
  &.text-primary {
    color: $colorMain;
  }

  &.text-white {
    background: $colorMain;
  }

  &__logo {
    width: 145px;
    transition: all .2s;

    @media (min-width: theme('screens.md')) {
      width: 165px;
    }
  }
}
</style>